import { Layout } from '@shared/components/Layout';
import { Abas } from '@shared/components/Abas';
import { ABAS, ABA_PADRAO } from '@curso/abas';
import { Abertura } from '@curso/sections/Abertura';
import { ChamadaFinal } from '@curso/sections/ChamadaFinal';
import { PaginaSaida } from '@inscricao/components/PaginaSaida';
import { PaginaPrivacidade } from '@inscricao/components/PaginaPrivacidade';

/**
 * A ordem da página.
 *
 * Abertura compacta em cima, para a moldura de abas aparecer sem rolagem.
 * Todo o miolo vive dentro das abas. O fecho fica sempre visível, para que
 * nenhuma aba termine sem saída.
 */
export function App() {
  /*
    As paginas avulsas. Sem roteador: com tres paginas, um if resolve, e o
    Netlify ja devolve o index.html para qualquer caminho.
  */
  const caminho = window.location.pathname.replace(/\/$/, '');
  if (caminho === '/sair') return <PaginaSaida />;
  if (caminho === '/privacidade') return <PaginaPrivacidade />;

  return (
    <Layout>
      <Abertura />
      <Abas abas={ABAS} padrao={ABA_PADRAO} />
      <ChamadaFinal />
    </Layout>
  );
}
